import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, computed } from 'vue';
import { FilterCollection } from '@/stores/filter.store';
import HeadlinedTitleList from '@/components/HeadlinedTitleList.vue';
import { Platform, PopularTitlesSorting } from '@/@types/graphql-types';
import { useLanguageStore } from '@/helpers/composables/useStores';
import {
	GetPopularTitlesDocument,
	GetPopularTitlesQuery,
	GetPopularTitlesQueryVariables,
} from '@/pages/graphql/queries/GetPopularTitles.query';
import { useQuery } from '@/helpers/composables/useApollo';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';


export default /*#__PURE__*/_defineComponent({
  __name: 'PopularTitles',
  props: {
    title: null,
    excludeTitleId: null,
    filters: null,
    sortBy: { default: PopularTitlesSorting.Popular },
    minTitles: { default: 1 },
    additionalContexts: { default: () => [] },
    impressionTrackingLabel: { default: '' },
    impressionTrackingProperty: { default: '' }
  },
  setup(__props: any) {

const props = __props as { title: TitleDetail, excludeTitleId: String, filters?: FilterCollection, sortBy: PopularTitlesSorting, minTitles: number, additionalContexts: SnowplowContext[], impressionTrackingLabel: string, impressionTrackingProperty: string };



const { language, country } = useLanguageStore();

const queryVariables = computed<GetPopularTitlesQueryVariables>(() => {
	return {
		first: 10,
		popularTitlesFilter: props.filters,
		watchNowFilter: {},
		popularTitlesSortBy: props.sortBy,
		language: language.value,
		country: country.value,
		platform: Platform.Web,
	};
});

const { result: popularTitlesProviderData } = useQuery<GetPopularTitlesQuery>(
	GetPopularTitlesDocument,
	queryVariables,
	{ errorPolicy: 'all' }
);

const titles = computed(() => {
	return (
		popularTitlesProviderData.value?.popularTitles?.edges
			?.map(el => el.node)
			.filter(el => el.id !== props.excludeTitleId) ?? []
	);
});

const isEmpty = computed(() => {
	return titles.value.length < props.minTitles;
});

return { __sfc: true,props, language, country, queryVariables, popularTitlesProviderData, titles, isEmpty, HeadlinedTitleList }
}

})